// extracted by mini-css-extract-plugin
module.exports = {"advantageLabel":"AdvantageLabel_advantageLabel__T2FGP","advantageIcon":"AdvantageLabel_advantageIcon__LvUnc","negative":"AdvantageLabel_negative__OK1kC"};